"use client";

import { useEffect } from "react";
import { registerOfflineServiceWorker } from "@/lib/offline/prepare";

export function ServiceWorkerRegistration() {
  useEffect(() => {
    void registerOfflineServiceWorker().catch(() => {
      // The field workspace reports readiness and offers explicit setup retry.
      // Other online pages remain usable if this browser cannot install a worker.
    });
  }, []);

  return null;
}
